import { OrderInformation } from '@app/components/orders/OrderInformation';
import { Skeleton } from '@app/components/various/Skeleton';
import { SkeletonLayout } from '@app/components/various/SkeletonLayout';
import { getUser } from '@app/ducks/user';
import { getIsOrderEditable } from '@app/logic/Orders';
import { useAvailableOrderDetails } from '@app/utils/hooks/useAvailableOrderDetails';
import { isDefined } from '@app/utils/is';
import { Order } from '@typings';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { CheckoutSummaryActions } from './CheckoutSummaryActions';

interface Props {
  isDisabled?: boolean;
  orderDetails: Order.Single;
}

export const CheckoutSummary = ({ isDisabled = false, orderDetails }: Props) => {
  const user = useSelector(getUser);
  const { t } = useTranslation(['orders', 'selections']);
  const { orderStatus, orderNumber } = useAvailableOrderDetails();
  const isOrderEditable = isDefined(orderStatus) && getIsOrderEditable(orderStatus);
  const orderTitle = t(isOrderEditable ? 'selections:selection_number' : 'orders:order_number', {
    orderNumber,
  });

  return (
    <>
      <div className="mb-6 flex flex-wrap items-center justify-between gap-x-4 gap-y-3">
        <SkeletonLayout isLoading={!isDefined(orderStatus)} skeleton={<Skeleton type="text" size="xlarge" itemClassName="max-w-36" />}>
          <h2 className="heading-1">{orderTitle}</h2>
        </SkeletonLayout>
        <CheckoutSummaryActions user={user} isDisabled={isDisabled} />
      </div>
      <OrderInformation orderDetails={orderDetails} isEditable={isOrderEditable} />
    </>
  );
};
